import './index.css';

import config from './config';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from './pages/Home';
import ImplementationPage from './pages/Implementation';

function App() {
  window.config = config;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/application" element={<ImplementationPage />} />
      </Routes>
    </Router>
  );
}

export default App;
